module.exports = "/assets/data/5843b2d4f69b888dd550a67271b08093-KA14.data.json";